import { DocumentAttributeValueTypeEnum } from "../facets/utils"

export class AvailableSortingAttributesManager {
 constructor(sortingAttributes) {
  this.sortingAttributes = sortingAttributes
 }

  static empty() {
    return new AvailableSortingAttributesManager([])
  }

  set(sortingAttributes) {
    return new AvailableSortingAttributesManager(sortingAttributes)
  }

  get() {
    return this.sortingAttributes
  }

  // Get sorting attributes from index metadata
  // Store date type sorting attirbute before other types
  // Set avaialble attributes
  fromIndexMetadata(configList ) {
    let sortingAttributeDateList = []
    let sortingAttributeOtherList = []

    if (configList) {
      for (const documentMetadataConfig of configList) {
        if (documentMetadataConfig && documentMetadataConfig.Search?.Sortable) {
          if (
            documentMetadataConfig.Type ===
            DocumentAttributeValueTypeEnum.DateValue
          ) {
            sortingAttributeDateList.push(documentMetadataConfig.Name)
          } else {
            sortingAttributeOtherList.push(documentMetadataConfig.Name)
          }
        }
      }
    }
    const sortingAttributeList = sortingAttributeDateList.concat(
      sortingAttributeOtherList
    )

    return new AvailableSortingAttributesManager(sortingAttributeList)
  }
}



// WEBPACK FOOTER //
// ./src/containers/Kendra/sorting/AvailableSortingAttributesManager.js